<template>
  <el-dialog
    :visible='true'
    title='添加素材'
    :before-close='handleClose'
    width='600px'
    :close-on-click-modal='false'
    :append-to-body="true"
  >
  <div style="display: flex;">
    <div class="form">
      <el-form label-width="120px" size="small">
        <el-form-item label="素材名称：">
          <el-input 
            size="small" 
            style="width: 250px;"
            v-model="mediaName" 
            placeholder="使用场景或尺寸说明"
            maxlength="15" 
            show-word-limit>
          </el-input>
        </el-form-item>
        <el-form-item label="素材类型：">
          <el-radio-group v-model="mediaType">
            <el-radio :label="1">图片</el-radio>
            <el-radio :label="2">视频</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="素材内容：" v-if="mediaType == 1">
          <el-upload class="upload" :action="`/jd-yusms/sms/upload/media-file/${mediaType}`"
            accept=".jpg,.jpeg,.png" :before-upload="beforeUpload" :on-success="handleUploadSuccess"
            :on-error="handleError" :file-list="picList" :on-remove="handleRemove" style="position: relative;">
            <el-button size="small"><img src="@/assets/images/上传.png" />点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              <p>支持格式：jpeg、jpg、png</p>
              <p>尺寸建议：16:9、1:1、48:65</p>
              <p>文件大小：最大2M，建议100k</p>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="素材内容：" v-else>
          <el-upload class="upload" :action="`/jd-yusms/sms/upload/media-file/${mediaType}`"
            accept=".mp4" :before-upload="beforeUpload" :on-success="handleUploadSuccess"
            :on-error="handleError" :file-list="videoList" :on-remove="handleRemove" style="position: relative;">
            <el-button size="small"><img src="@/assets/images/上传.png" />点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              <p>支持格式：mp4</p>
              <p>尺寸建议：16:9</p>
              <p>文件大小：最大10M</p>
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
    </div>
    <div class="iphone"></div>
  </div>
  <template #footer>
    <div class='dialog-bottom'>
      <el-button @click='handleClose' type='secondary' size='small'>取消</el-button>
      <el-button @click='handleConfirm' type='primary' size='small'>确定</el-button>
    </div>
  </template>
  </el-dialog>
</template>

<script>
import { saveCardFile } from '@/api/backstage/smsCard'
export default {
 name: '' ,
 components: {},
 props:{
  visible: {
    type: Boolean,
    default: false,
  },
 },
 data() {
 return {
  totalSize:'',
  mediaName:'',
  mediaType:1,
  picObject:null,
  picList: [], // 图片文件列表
  videoObject:null,
  videoList: [], // 视频文件
 }
 },
 computed: {},
 created() {
 
 },
 mounted() {
 
 },
 methods: {
  handleClose() {
   this.$emit('close');
  },
  handleConfirm() {
    if(!this.mediaName){
      this.$message.warning("请填写素材名称！");
      return
    }
    if(this.mediaType == 1 && !this.picObject){
      this.$message.warning("请上传素材内容！");
      return
    }
    if(this.mediaType == 1 && !this.picObject){
      this.$message.warning("请上传素材内容！");
      return
    }
    let params = {
      totalSize:this.mediaType == 1 ? this.picObject.fileSize : this.videoObject.fileSize,
      mediaName:this.mediaName,
      mediaType:this.mediaType,
      mediaObject:this.mediaType == 1 ? this.picObject : this.videoObject,
    }
    saveCardFile(params).then(res=>{
      if(res.code == 1){
        this.$message.success('添加成功')
        this.$emit('confirm');
      }else{
        this.$message.error(res.message);
      }
    })
  },
  // 上传前校验
  beforeUpload(file) {
    let _this = this;
    console.log(file);
    // 获取当前剩余可上传文件大小
    let mSize = this.mediaType == 1 ? 2 : 10;
    let surplusSize = mSize * 1024 * 1024;
    // 控制单个文件的上传大小  字节
    if (file.size > surplusSize) {
      this.$message.warning(`文件上传失败，内容大小不超过${mSize}M`);
      return false;
    }
    let types1 = ['.jpeg', '.png', '.jpg']
    let types2 = ['.mp4']
    let type = file.name.substring(file.name.lastIndexOf("."));
    if (this.mediaType == 1 && this.compare(type, types1) == false) {
      this.$message.warning("所选文件格式不符，请重新选择图片");
      return false;
    } else if (this.mediaType == 2 && this.compare(type, types2) == false) {
      this.$message.warning("所选文件格式不符，请重新选择视频");
      return false;
    }
  },
  compare(str, ary) {
    let flag = false
    ary.forEach(item => {
      if (str.toLowerCase() == item.toLowerCase()) {
        flag = true
      }
    })
    return flag
  },
  // 上传成功
  async handleUploadSuccess(res, file, fileList) {
    if (res.code == 1) {
      if(this.mediaType == 1){
        this.picObject = res.data
        this.picList = [{ name: res.data.mulitiFileName, url: res.data.fileUrl }]
      }else{
        this.videoObject = res.data
        this.videoList = [{ name: res.data.mulitiFileName, url: res.data.fileUrl }]
      }
      
    } else {
      this.$message.error(res.message);
    }
  },
  // 上传失败
  handleError(err) {
    this.$message.error("上传失败");
  },
  handleRemove(){
    if(this.mediaType == 1){
      this.picList = [];
      this.picObject = null;
    }else{
      this.videoList = [];
      this.videoObject = null;
    }
  }
 }
}
</script>
<style lang='scss' scoped>

.dialog-bottom {
  text-align: right;
}
.upload {
  margin: 0px 10px;
  display: inline-block;

  .el-button {
    background-color: #FFF6F6 !important;
    border: 1px solid #FE4D45 !important;
    color: #FE4D45 !important;

    &:hover {
      background-color: #ffe5e5 !important;
    }

    &:active {
      background-color: #fff4f4 !important;
    }
  }

  img {
    width: 15px;
    margin-right: 2px;
    position: relative;
    top: 2px;
  }
}

.tips {
  display: flex;

  .img {
    display: inline-block;
    position: absolute;
    left: 14px;
    top: 14px;
    width: 14px;
    height: 14px;
    color: #ffffff;
  }

  >div:nth-child(1) {
    width: 90px;
  }

  >div:nth-child(2) {
    font-size: 13px;
    flex: 1;

    p {
      line-height: 20px;
    }

    >p:nth-child(1) {
      margin-top: 6px;
    }
  }
}
.el-upload__tip {
  font-size: 12;
  color: #999999;

  p {
    line-height: 20px;
  }
}

/deep/ .el-upload-list__item {
  transition: none !important
}
</style>